import React from 'react'
import { PrivacyPolicyPage } from '../components/PrivacyPolicyPage'

export const PrivacyPolicy = ({history}) => {
    return (
        <React.Fragment>
            <PrivacyPolicyPage history={history} />
        </React.Fragment>
    )
}
